<div fxLayout="row"  fxLayout.lt-md="column"
fxLayoutGap="10px">

	<button [attr.guide]="'database-rule-action-component-advanced-btn-1-1' + '__' + sanitizeUrl(url)" mat-raised-button  (click)="addGroupMain()">
    add nested group
  </button>

	<button [attr.guide]="'database-rule-action-component-advanced-btn-2-1' + '__' + sanitizeUrl(url)" mat-raised-button (click)="addConditionMain()">
    add condition
  </button>
	<button [attr.guide]="'database-rule-action-component-advanced-btn-3-1' + '__' + sanitizeUrl(url)" *ngIf="index!='Group 1:'"   mat-raised-button (click)="remove.emit()">
    delete group
  </button>
</div>
